//Core
import React from "react"

//Styled
import style from "./style.module.scss"

//Images
import rules_third from "../../../images/credit/rules_third.png"
import rules_second from "../../../images/credit/rules_second.png"
import rules_first from "../../../images/credit/rules_first.png"

const {
  container,
  wrapper,
  title,
  rulesBox,
  rule,
  helper,
  textWrapper,
  textWrapperTitle,
  info,
  Link,
  imageWrapper,
  blueDots,
  redDots,
  mainImage,
} = style

const Rule = ({ img, text, specialText }) => (
  <div className={rule}>
    <img src={img} alt="icon"></img>
    <div>
      <span>{specialText}</span> {text}
    </div>
  </div>
)

const Rules = () => {
  return (
    <div className={container}>
      <div className={wrapper}>
        <h3 className={title}>Умови надання Кредитних канікул</h3>
        <div className={rulesBox}>
          <Rule
            img={rules_first}
            specialText="Строк Кредитних канікул"
            text={` – 3 місяці (квітень, травень, червень)`}
          ></Rule>
          <Rule
            img={rules_second}
            specialText="Обов’язкові платежі складаються"
            text={`із суми процентів та щомісячної комісії`}
          ></Rule>
          <Rule
            img={rules_third}
            specialText="Дата закінчення кредиту та дата внесення обов’язкових платежів"
            text={`не змінюються`}
          ></Rule>
        </div>
        <div className={helper}>
          <div className={textWrapper}>
            <h4 className={textWrapperTitle}>Що це значить?</h4>
            <div className={info}>
              Для клієнтів банку, які відповідають вимогам Кредитних канікул та
              прийняли рішення скористатися пропозицією, платежі будуть містити
              проценти за кредитом та щомісячну комісію, якщо вона передбачена
              умовами договору. А погашення платежів за тілом кредиту
              відтерміновується на липень 2020 року. В той же час, участь у
              Кредитних канікулах не обмежує клієнтів здійснювати часткове
              погашення тіла кредиту, якщо є така можливість.
            </div>
            <a
              className={Link}
              href={`https://tascombank.ua/files/Sposoby_pogashennia_kredytu_AT_TASKOMBANK%5b12905%5d.pdf`}
            >
              Способи погашення платежів за кредитом
            </a>
          </div>
          <div className={imageWrapper}>
            <div className={blueDots}></div>
            <div className={mainImage}></div>
            <div className={redDots}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Rules
